import { render } from "./Workspace.vue?vue&type=template&id=2c971b3f&scoped=true&ts=true"
import script from "./Workspace.vue?vue&type=script&lang=ts"
export * from "./Workspace.vue?vue&type=script&lang=ts"

import "./Workspace.vue?vue&type=style&index=0&id=2c971b3f&scoped=true&lang=scss"

import exportComponent from "/vercel/path0/apps/builder-legacy/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c971b3f"]])

export default __exports__